import { useEffect, useState } from 'react'

import { AppLoading } from '@/components/AppLoading'

import { CustomConfirmDialog } from '@/components/CustomConfirmDialog'
import { Apps } from '@/dtos'
import { useInvokeBmw } from '@/hooks/useOffer'
import { Box, Button, Stack, Text, useDisclosure } from '@chakra-ui/react'
import { setInterceptorLogoutCallback } from 'BrokerTsLib/src/Utils/apiClient'
import { useNavigate, useParams } from 'react-router'
import { useAuth } from '../context/AuthContext'
import { useApp } from '../hooks/useApp'

export const WithAuth = <T extends object>(WrappedComponent: React.ComponentType<T>) => {
  const NewComponent = (props: T) => {
    const { user, isLoading, isLoggingOut, logout } = useAuth()
    const { isOpen: isOpenBmwLogoutModal, onOpen: onOpenBmwLogoutModal, onClose: onCloseBmwLogoutModal } = useDisclosure()

    const { app, lastApp } = useApp()

    const [showComponent, setShowComponent] = useState(false)

    const isLogged = !!user?.logged
    const buildDate = user?.buildDate

    const navigate = useNavigate()
    useEffect(() => {
      if (isLoggingOut)
        setShowComponent(false)
      else if (!isLogged && !isLoading) {
        navigate(`/auth/login?returnUrl=${encodeURIComponent(window.location.href)}`)
      }
      else if (isLogged)
        setShowComponent(true)
    }, [isLogged, user, isLoggingOut, lastApp, isLoading, navigate])

    useEffect(() => {
      if (!!buildDate && user) {
        // vynucení reload stránky, pokud se změní verze API
        const lastBuildDate = window.localStorage.getItem('api-build-date')
        window.localStorage.setItem('api-build-date', buildDate)

        if (buildDate !== lastBuildDate) window.location.reload()
      }
    }, [buildDate, user])

    // registrace aut. odhlaseni v pripade server response status code 401
    const logoutCallback = () => {
      if (lastApp?.app == Apps.leasingSimplifiedWizard)
        return onOpenBmwLogoutModal()

      logout()
    }

    setInterceptorLogoutCallback(logoutCallback)

    const { insuranceParamsId } = useParams()
    const [isGoingBack, setIsGoingBack] = useState(false)
    const { mutateAsync: invokeBmwAsync } = useInvokeBmw()

    return <>
      {showComponent
        ? <WrappedComponent {...props} />
        : <AppLoading />
      }

      {app == Apps.leasingSimplifiedWizard &&
        <CustomConfirmDialog
          isOpen={isOpenBmwLogoutModal}
          onClose={onCloseBmwLogoutModal}
          title="Platnost autentizace vypršela"
          yesButton={{
            customElement: (
              <Button
                variant="solid"
                colorScheme="green"
                color='white'
                isLoading={isGoingBack}
                isDisabled={isGoingBack}
                onClick={() => {
                  setIsGoingBack(true)
                  invokeBmwAsync({ action: 'Cancel', paramsId: insuranceParamsId! })
                    .catch(() => {
                      alert('Při zpracování požadavku došlo k chybě')
                    })
                    .finally(() => {
                      setIsGoingBack(false)
                      onCloseBmwLogoutModal()
                    })
                }}
                ml={3}
              >
                Rozumím
              </Button>
            )
          }}
          noButton={{
            customElement: <Box></Box>,
            onClick: onCloseBmwLogoutModal,
          }}>
          <Stack>
            <Text>Kliknutím na 'Rozumím' dojde k přesměrování zpět do původní aplikace.</Text>
          </Stack>
        </CustomConfirmDialog>
      }
    </>
  }

  return NewComponent
}
